import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { createQrZone, deleteQrZone, fetchQrZones, rotateQrZone, updateQrZone } from "../../../api/branchQr";
import { errorCode } from "../../../api/client";

// حالة مناطق QR للفرع: تحميل، إضافة، تدوير الرمز، تشغيل/إيقاف، وحذف.
export const useQrZones = (branchId) => {
  const { t } = useTranslation();
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!branchId) return;
    setLoading(true);
    try {
      setZones(await fetchQrZones(branchId));
    } catch {
      setZones([]);
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    load();
  }, [load]);

  const guard = async (fn, okKey) => {
    try {
      await fn();
      toast.success(t(okKey));
      await load();
    } catch (err) {
      const { code } = errorCode(err);
      toast.error(t(`errors.${code}`, { defaultValue: t("errors.generic") }));
    }
  };

  return {
    zones,
    loading,
    add: (body) => guard(() => createQrZone(branchId, body), "qr.created"),
    rotate: (id) => guard(() => rotateQrZone(branchId, id), "qr.rotated"),
    toggle: (zone) => guard(() => updateQrZone(branchId, zone.id, { active: !zone.active }), "qr.saved"),
    remove: (id) => guard(() => deleteQrZone(branchId, id), "qr.deleted"),
  };
};
